import { render, staticRenderFns } from "./history-task-detail.vue?vue&type=template&id=6e3c1240&scoped=true&"
import script from "./history-task-detail.vue?vue&type=script&lang=js&"
export * from "./history-task-detail.vue?vue&type=script&lang=js&"
import style0 from "./history-task-detail.vue?vue&type=style&index=0&id=6e3c1240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c1240",
  null
  
)

export default component.exports